(function ($, Notifikacija) { 
    Notifikacija.provjeriNotifikacijePeriodicki = provjeriNotifikacijePeriodicki;

    notifikacijaInterval = 60000;
    notifikacijaObjekt = null;
    var panel = $("#dropdown-notifikacijapanel");
    var notifikacije = null;
    var brojNotifikacija = 0;

    var kontoSifarnik = null;
    var refreshAfterNovaNotifikacija = false;    
    var refreshAfterNotifikacijaProcitana = false;
    
    function afterProcitano(){
    	if(konto.Notifikacija.kontoSifarnik){
	    	var doAfterNotifikacijaProcitana = $(".main-grid").attr("data-doAfterNotifikacijaProcitana");
			if(doAfterNotifikacijaProcitana){
				if(konto.Notifikacija.refreshAfterNotifikacijaProcitana){
					konto.Notifikacija.kontoSifarnik.kontoGrid.refresh(true);
					konto.Notifikacija.refreshAfterNotifikacijaProcitana = false;	
				}							
			}
    	}    		
    }

    function afterNovaNotifikacija(){
    	if(konto.Notifikacija.kontoSifarnik){
	    	var doAfterNovaNotifikacija = $(".main-grid").attr("data-doAfterNovaNotifikacija");
			if(doAfterNovaNotifikacija){
				if(konto.Notifikacija.refreshAfterNovaNotifikacija){
					konto.Notifikacija.kontoSifarnik.kontoGrid.refresh(true);
					konto.Notifikacija.refreshAfterNovaNotifikacija = false;	
				}							
			}
    	}    		
    }    

    function ispisi(id){		
		var httpM = "POST";
		var isAndroid = KUtils.isAndroid();
        if (isAndroid){
			httpM = "GET";
		}		
        $.fileDownload(kontorouter.getModulPath("notifikacija/ispis/" + id) + "?fileDownload", {
            httpMethod: httpM,
            prepareCallback: function (url) {
                dlg = konto.dialogs.modal({
                    title: "Generiranje izvještaja",
                    content: "Molimo pričekajte."
                });
            },
            successCallback: function () {
                if (dlg){
                    dlg.close();
                }
                notifikacijaProcitana(id);
            },
            failCallback: function (responseHtml, url) {
                KUtils.busy(false);
                if (dlg)
                    dlg.close();
            
                // JSON greške bi se mogle naći u HTML-u.
                var ispisan = false;
                var html = $(responseHtml);   
                try {                      
                    var json = $.parseJSON(html.text());
                    if (json && json.error) {
                        ispisan = true;
                        $.dialogGreska({
                            content: json.error
                        });
                    }
                }
                catch (e) { }
                
                if (ispisan === false) {
                    if (responseHtml == '')
                        responseHtml = "Nema podataka za zadane parametre. Provjerite i promijenite unesene parametre izvještaja.";
                     $.dialogGreska({
                        content: responseHtml
                    });
                }
            }
        });

    }

	function kreirajRedak(data){
		var red = vratiRedak(data);
		red.appendTo(panel);		
	}
	
    function vratiRedak(data){   	                   	
        var redak = $("<li>", {
            id: data.FNotifikacija,
            class: "nav-item"
        });
        var link = $("<a>",{
            href: "#",
            class: "notifikacijaLink nav-link" 
        });       
        var link1 = $("<a>",{
            href: "#",
            class: "notifikacijaLink1" 
        });    
        var puniOpis = '';
        var puniOpisOpis = data.FPuniOpisOpis;        
        if(data.FPuniOpisOpis && data.FPuniOpisOpis.length > 200){
        	puniOpis = data.FPuniOpisOpis;	
        }
             
        var info = '';
        if(data.FPuniOpisInfo){
        	info = data.FPuniOpisInfo;	
        }
        
        var opis = $("<span>",{
            class: "opis",
            text: data.FOpis,
            title: puniOpis,
            click: function(e){
            	if(info != ''){
					e.stopPropagation();
                    $.dialogGreska({
                        content: info
                    });					
            	}               
            }             
        });       
        var opisGreska = $("<span>",{
            class: "opis",
            text: data.FOpis,
            style: "color: red; font-weight: bold;",
            title: puniOpis
        });    
        
        var opisIzvjestajGotov = $("<span>",{
            class: "opis",
            text: data.FOpis,
            title: "Pregled izvještaja",
            style: "font-weight: bold;"
        });
        var opisObradaGotova = $("<span>",{
            class: "opis",
            text: data.FOpis,
            title: "Pregled rezultata obrade",
            style: "font-weight: bold;"            
        });

        var ikonaObavijest = $("<i>",{
            class: "fas fa-info-circle",
            style: "color: blue; font-size: medium; vertical-align: middle;",
            title: "Obavijest"
        });

        var ikonaInfo = $("<i>",{
            class: "fas fa-question-circle",
            style: "color: orange; font-size: medium; vertical-align: middle;",
            title: "Info"
        });
        
        var ikonaUTijeku = $("<i>",{
            class: "fas fa-cog fa-spin",
            style: "color: blue; font-size: medium; vertical-align: middle;",
            title: "Generiranje u tijeku..."
        });
                
        var ikonaGreska = $("<i>",{
            class: "fas fa-exclamation-triangle",
            style: "color: red; font-size: medium; vertical-align: middle;",
            title: "Greška" 
        });
        var ikonaPdf = $("<i>",{
            class: "far fa-file-pdf",
            style: "color: red; font-size: medium; vertical-align: middle;",
            title: "PDF dokument"
        });
        var ikonaXls = $("<i>",{
            class: "far fa-file-excel",
            style: "color: limegreen; font-size: medium; vertical-align: middle;",
            title: "Excel dokument"
        });
        var ikonaWord = $("<i>",{
            class: "far fa-file-word",
            style: "color: blue; font-size: medium; vertical-align: middle;",
            title: "Word dokument"
        });
        var ikonaArchive = $("<i>",{
            class: "far fa-file-archive",
            style: "font-size: medium; vertical-align: middle;",            
            title: "Zip/Rar dokument"
        });
        var ikonaText = $("<i>",{
            class: "far fa-file-alt",
            style: "font-size: medium; vertical-align: middle;",            
            title: "Txt dokument"
        });        
        var ikonaIzvjestaj = $("<i>",{
            class: "fas fa-print",            
            title: "Izvještaj"
        });
        var ikonaObrada = $("<i>",{
            class: "fas fa-cog notifikacijaIspis",
            title: "Obrada"
        });        

        var ikonaObrisi = $("<i>",{
            class: "far fa-trash-alt desno",
            title: "Ukloni s liste",
            style: "color:#DA0000; font-size: medium; vertical-align: middle;",
            click: function(e){
            	e.stopPropagation();
                notifikacijaProcitana(data.FNotifikacija);                    
            }
        });        

        var ikonaObrisiSve = $("<i>",{
            class: "fas fa-ban desno",
            title: "Ukloni sve sa liste",
            style: "color:#DA0000; font-size: medium; vertical-align: middle;",
            click: function(e){
            	e.stopPropagation();            	
                notifikacijeProcitane();                    
            }
        });        

        switch (data.FVrstaNotifikacije) {
            case 1: //obavijest
                ikonaObavijest.appendTo(link);
                if(info != ''){
                	ikonaInfo.appendTo(link); 
                }               
                opis.appendTo(link);
                link.on('click', function(e){
               		e.stopPropagation();               		
	            	if(info != ''){
	            		var info2 = puniOpisOpis + '</br></br>' + info;
	                    $.dialogGreska({
	                        content: info2
	                    });					
	            	} 
	            	else {
	                    $.dialogGreska({
	                        content: puniOpisOpis
	                    });	            		
	            	}                           		               		               		
                });		                                
                break;
            case 2: //greška
                ikonaGreska.appendTo(link);
                if(info != ''){
                	ikonaInfo.appendTo(link);
                } 
                opisGreska.appendTo(link);
                link.on('click', function(e){
                	e.stopPropagation();
	            	if(info != ''){
	            		var info2 = puniOpisOpis + '</br></br>' + info;
	                    $.dialogGreska({
	                        content: info2
	                    });					
	            	} 
	            	else {
	                    $.dialogGreska({
	                        content: puniOpisOpis,
	                        close: function(e){
	                        	notifikacijaProcitana(data.FNotifikacija);
	                        }
	                    });	  							                              		
	            	}                 	
                });		            
                ikonaObrisi.appendTo(link1);
                break;
            case 3: //izvještaj/obrada se generira
                ikonaUTijeku.appendTo(link);
                if(info != ''){
                	ikonaInfo.appendTo(link);
                }                 
                opis.appendTo(link);
                link.on('click', function(e){ 
					e.stopPropagation();  
					if(info != ''){
	            		var info2 = puniOpisOpis + '</br></br>' + info;
	                    $.dialogGreska({
	                        content: info2
	                    });					
	            	} 
	            	else {
	                    $.dialogGreska({
	                        content: puniOpisOpis
	                    });	  							                              		
	            	} 
                });		                                
                break;
            case 4: //kraj generiranja izvještaja / kraj obrade
		        switch (data.FTipNotifikacije) {
        	    	case 1: //izvještaj            
		                if (data.FImeDatoteke.toLowerCase().indexOf(".pdf")>1) {
		                    ikonaPdf.appendTo(link);    
		                }
		                else if ((data.FImeDatoteke.toLowerCase().indexOf(".xls")>1) || (data.FImeDatoteke.toLowerCase().indexOf(".xlsx")>1)) {            
			            	ikonaXls.appendTo(link);
		                }
   		                else if ((data.FImeDatoteke.toLowerCase().indexOf(".doc")>1) || (data.FImeDatoteke.toLowerCase().indexOf(".docx")>1)) {            
			                ikonaWord.appendTo(link);
		                }
		                else if ((data.FImeDatoteke.toLowerCase().indexOf(".zip")>1) || (data.FImeDatoteke.toLowerCase().indexOf(".rar")>1)) {            
			                ikonaArchive.appendTo(link);
		                }
		                else if ((data.FImeDatoteke.toLowerCase().indexOf(".xls")>1) || (data.FImeDatoteke.toLowerCase().indexOf(".xlsx")>1)) {            
			                ikonaXls.appendTo(link);
		                }
		                else if ((data.FImeDatoteke.toLowerCase().indexOf(".txt")>1) || (data.FImeDatoteke.toLowerCase().indexOf(".xml")>1)) {            
			                ikonaText.appendTo(link);
		                }
			            else {
			                ikonaIzvjestaj.appendTo(link);			            	
			            }
			            if(info != ''){
                			ikonaInfo.appendTo(link);
                		} 
		                opisIzvjestajGotov.appendTo(link);
		                link.on('click', function(e){
		                	e.stopPropagation();
		                    ispisi(data.FNotifikacija);		                		
		                });		                
		                ikonaObrisi.appendTo(link1);
		                break;
		            case 2: //obrada
		                ikonaObrada.appendTo(link);   
		                if(info != ''){
                			ikonaInfo.appendTo(link);
                		} 
		                opisObradaGotova.appendTo(link);
		                link.on('click', function(e){
							e.stopPropagation();		                	
		                	if (data.FImeDatoteke != '-'){
		                    	ispisi(data.FNotifikacija);		                		
		                	} else { 
				            	if(info != ''){
				            		var info2 = puniOpisOpis + '</br></br>' + info;
				                    $.dialogGreska({
				                        content: info2
				                    });					
				            	} 
				            	else {
				                    $.dialogGreska({
				                        content: puniOpisOpis,
				                        close: function(e){
				                        	notifikacijaProcitana(data.FNotifikacija);
				                        }
				                    });	  							                              		
				            	} 
		                	}
		                });			                	                
		                ikonaObrisi.appendTo(link1);                
		                break;                		            
		        }
                break;
        }
        link.appendTo(redak);
        link1.appendTo(redak);
        return redak;        
    }

    function kreirajNemaObavijesti(){
        var redak = $("<li style='text-align: center; font-weight: bold;'>", {
            id: 0,
            class: "nav-item",
        });
        var link = $("<a>",{
            href: "#",
            class: "notifikacijaLink nav-link" 
        });               
        var ikonaObavijest = $("<i>",{
            class: "fas fa-info-circle",
            style: "color: blue; font-size: medium; vertical-align: middle;",
            title: "Obavijest"
        });        
        var opis = $("<span>",{
            class: "opis",
            text: "Nema novih obavijesti"
        });
        
        ikonaObavijest.appendTo(link);
        opis.appendTo(link);
        link.appendTo(redak);        
        redak.appendTo(panel);
    }

    function notifikacijaProcitana(id){
        konto.sf.api.NotifikacijaProcitana(id)
		.then(function(res){   
			provjeriBrojNotifikacija();
			provjeriNotifikacije();
			afterProcitano();			
		});        
    }

    function notifikacijeProcitane(id){
        konto.sf.api.NotifikacijeProcitane()
		.then(function(res){        
			provjeriBrojNotifikacija();			
			provjeriNotifikacije();
		});        
    }

    function noveNotifikacije(res){
        var result = false;
        var resetirajInterval = false;
        if (res.length != notifikacije.length){
            result = true;
        }else{
            for (var index = 0; index < res.length; index++) {
                if (res[index].FNotifikacija != notifikacije[index].FNotifikacija){
                    result = true;
                } else if (res[index].FVrstaNotifikacije != notifikacije[index].FVrstaNotifikacije) {
                	// promjena vrste notifikacije (obavijest, greška, obrada, gotovo )
                	var navItem = '#' +  res[index].FNotifikacija;
					// zamijeni cijeli red jer je došlo do promjene vrste notifikacije
					var red = vratiRedak(res[index]);
                	$(navItem).html(red);                	
                	notifikacije[index].FVrstaNotifikacije = res[index].FVrstaNotifikacije;
                	resetirajInterval = true;                	                                    
                } else if (res[index].FOpis != notifikacije[index].FOpis) {
                	// samo ažuriraj opis notifikacije - obrada u tijeku
                	var navItem = '#' +  res[index].FNotifikacija;
                	$(navItem).find('.opis').text(res[index].FOpis);
                	notifikacije[index].FOpis = res[index].FOpis;
                	resetirajInterval = true;                	
                }            		
            }
            if (resetirajInterval) {            
				// resetirati interval za provjeru novih notifikacija pošto je neka obrada u tijeku, pa da se brže osvježe % obrade            	
            	provjeriNotifikacijePeriodicki();  
            }            
        }
        return result;
    }

    function kreirajNotifikacije(res){
        var brNotifikacija = 0;
		panel.text("");        
        for (var index = 0; index < res.length; index++) {
            if (res[index].FVrstaNotifikacije === 0)
                continue;
            kreirajRedak(res[index]);   
			if ((res[index].FVrstaNotifikacije === 2) || (res[index].FVrstaNotifikacije === 4)) { // greška ili gotovo            
            	brNotifikacija++;
           }
        } 
        if (brNotifikacija != brojNotifikacija){
            setBrojNotifikacija(brNotifikacija);
        }
    }

	function prikaziOmotnicu(){
        if (brojNotifikacija != 0) { 
        	$("#ikonaNotifikacija").removeClass("hide");
        }		
	}
	
    function provjeriNotifikacije(){   	
        konto.sf.api.GetNotifikacija()
        .then(function(res){
            $("#dropdown-notifikacijapanel").setVisible();        	
            if (res && res.error){
                return;
            }            
            if (res.length === 0){
		        notifikacije = null;
		        panel.text("");
				kreirajNemaObavijesti();
            }else{
                if (!notifikacije){ 
                    notifikacije = res;
                    kreirajNotifikacije(res);
                } else if (noveNotifikacije(res) == true){
                    notifikacije = res;
                    panel.text("");
                    kreirajNotifikacije(res);
                }
            }
    		prikaziOmotnicu();   
        });
    }

    function resetirajBrojNotifikacija(){
        $("#panelNotifikacija").removeClass("konto-blink").removeClass("novaObavijest");
        if (brojNotifikacija == 0) {     
        	$("#ikonaNotifikacija").removeClass("fa-envelope").addClass("fa-envelope-o");
        }         
    }

    function setirajBrojNotifikacija(){
        $("#ikonaNotifikacija").removeClass("fa-envelope-o").addClass("fa-envelope");
    	var isMobile = KUtils.isMobile(); 
		if (isMobile == true){
			$("#ikonaNotifikacija").removeClass("fa-envelope")	
		}        
        $("#panelNotifikacija").addClass("konto-blink novaObavijest");     
        afterNovaNotifikacija();     
        setTimeout(function(){
             $("#panelNotifikacija").removeClass("konto-blink"); 
         }, 10000);
    }

	function setBrojNotifikacija(brNot){
	    var bn = $("#brojNotifikacija");
	    if (brNot === 0) {
	    	brojNotifikacija = 0;    	
	        bn.text("");
			resetirajBrojNotifikacija();            
	    }            
	    else {
	    	if (brNot != brojNotifikacija) {
	        	bn.text("(" + brNot + ")");
				if (brNot > brojNotifikacija) {	            	
					setirajBrojNotifikacija();
				}
				brojNotifikacija = brNot;					
			}            
	    }
		prikaziOmotnicu();   
	}	

    function provjeriBrojNotifikacija(){
        konto.sf.api.GetBrojNotifikacija()
        .then(function(res){
            if (res && res.error){
                return;
            }
			setBrojNotifikacija(res);
			if ($("#dropdown-notifikacijapanel").hasClass('show')) 					
				provjeriNotifikacije();
        });
    }
 
    function provjeriNotifikacijePeriodicki(){
        var intervali = [5000,10000,10000,20000,60000];
        var intervaliUkupno = 0;
        for (var index = 0; index < intervali.length; index++) {
            const interval = intervali[index];
            if (index < intervali.length-1){
                intervaliUkupno = intervaliUkupno + interval + 1000;
                notifikacijaObjekt = setTimeout (provjeriBrojNotifikacija, intervaliUkupno);                
            }else{
                setTimeout (function(){
                    notifikacijaObjekt = setInterval(provjeriBrojNotifikacija, interval);
                }, intervaliUkupno);                
            }
        }    
    }

    $(document).ready(function() { 
        if (panel.length > 0) {  
    		provjeriBrojNotifikacija(); //po ulasku na formu (ili refresh) provjeri broj notifikacija        	
            provjeriNotifikacijePeriodicki();  // postavlja interval za provjeru novih notifikacija
        }
  
    
		$('#panelNotifikacija').click(function() {		
			if ($("#dropdown-notifikacijapanel").hasClass('show')) {
		        notifikacije = null;
		        panel.text("");
		    	return true; //otvoren je dropdown, preskacem provjeru i zatvaram dropdown
		    }else{
		    	$("#dropdown-notifikacijapanel").setVisible(false);	
		    }
		    provjeriBrojNotifikacija();
		    provjeriNotifikacije();
			resetirajBrojNotifikacija();			
		});
		
	    setTimeout(function()
	    {
        	if (panel.length > 0) {  
		    	provjeriNotifikacije();
		    }
	    }, 10000);  		
		                            
		$('#dropdown-notifikacijapanel').click(function(e) {
			// da se ne zatvori pregled ako se klikne na prazninu iza opisa u samom redu			
			e.stopPropagation();			
		});		
    });

} (jQuery, konto.Notifikacija = konto.Notifikacija || {}));